<template>
  <q-dialog v-model="dialogVisible" @hide="$emit('hide')">
    <q-card class="upload-guide-card">
      <q-card-section class="row items-center q-pb-sm">
        <q-icon name="cloud_upload" color="primary" size="32px" class="q-mr-sm" />
        <div>
          <div class="text-h6">{{ $t('addMedia.guide.title') }}</div>
          <div class="text-caption text-grey-7">{{ $t('addMedia.guide.intro') }}</div>
        </div>
      </q-card-section>

      <q-tabs
        v-model="activeTab"
        dense
        no-caps
        align="left"
        active-color="primary"
        indicator-color="primary"
        class="text-grey-7"
      >
        <q-tab name="how" icon="verified_user" :label="$t('addMedia.guide.tabs.how')" />
        <q-tab name="faq" icon="help_outline" :label="$t('addMedia.guide.tabs.faq')" />
      </q-tabs>

      <q-separator />

      <q-tab-panels v-model="activeTab" animated>
        <q-tab-panel name="how" class="q-px-md q-pt-md q-pb-sm">
          <ul class="upload-guide-list text-body2">
            <li>{{ $t('addMedia.guide.resumeAfterRefresh') }}</li>
            <li>{{ $t('addMedia.guide.pause') }}</li>
            <li>{{ $t('addMedia.guide.resumeLater') }}</li>
            <li>{{ $t('addMedia.guide.autoRetry') }}</li>
          </ul>
        </q-tab-panel>

        <q-tab-panel name="faq" class="q-pa-none">
          <q-list separator>
            <q-expansion-item
              dense-toggle
              icon="wifi_off"
              :label="$t('addMedia.guide.faq.offlineQuestion')"
            >
              <q-card-section class="text-body2 q-pt-none">
                {{ $t('addMedia.guide.faq.offlineAnswer') }}
              </q-card-section>
            </q-expansion-item>

            <q-expansion-item
              dense-toggle
              icon="refresh"
              :label="$t('addMedia.guide.faq.closedQuestion')"
            >
              <q-card-section class="text-body2 q-pt-none">
                {{ $t('addMedia.guide.faq.closedAnswer') }}
              </q-card-section>
            </q-expansion-item>

            <q-expansion-item
              dense-toggle
              icon="broken_image"
              :label="$t('addMedia.guide.faq.failedQuestion')"
            >
              <q-card-section class="text-body2 q-pt-none">
                {{ $t('addMedia.guide.faq.failedAnswer') }}
              </q-card-section>
            </q-expansion-item>

            <q-expansion-item
              dense-toggle
              icon="schedule"
              :label="$t('addMedia.guide.faq.laterQuestion')"
            >
              <q-card-section class="text-body2 q-pt-none">
                {{ $t('addMedia.guide.faq.laterAnswer') }}
              </q-card-section>
            </q-expansion-item>
          </q-list>
        </q-tab-panel>
      </q-tab-panels>

      <q-card-section class="q-pt-sm">
        <q-banner rounded class="bg-orange-1 text-dark">
          <template v-slot:avatar>
            <q-icon name="info" color="orange-9" />
          </template>
          {{ $t('addMedia.guide.keepFiles') }}
        </q-banner>
      </q-card-section>

      <q-card-actions align="right">
        <q-btn
          flat
          color="primary"
          :label="$t('addMedia.guide.gotIt')"
          @click="dialogVisible = false"
        />
      </q-card-actions>
    </q-card>
  </q-dialog>
</template>

<script>
export default {
  name: 'UploadGuideDialog',
  emits: ['update:modelValue', 'input', 'hide'],
  props: {
    modelValue: {
      type: Boolean,
      default: null,
    },
    value: {
      type: Boolean,
      default: false,
    },
  },
  data() {
    return {
      activeTab: 'how',
    };
  },
  computed: {
    dialogVisible: {
      get() {
        return this.modelValue !== null ? this.modelValue : this.value;
      },
      set(nextValue) {
        this.$emit('update:modelValue', nextValue);
        this.$emit('input', nextValue);
      },
    },
  },
};
</script>

<style lang="scss" scoped>
.upload-guide-card {
  width: 560px;
  max-width: 94vw;
  max-height: 90vh;
  overflow-y: auto;
}

.upload-guide-list {
  margin: 0;
  padding-left: 20px;

  li + li {
    margin-top: 10px;
  }
}
</style>
